import React, { useState, useEffect,useRef, useMemo } from "react";
import { useLocation, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Sidebar.css";
import { MdKeyboardArrowRight, MdKeyboardArrowDown, MdKeyboardArrowLeft, MdMenu } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";
import { useTheme } from "../../ThemeSwitcher/ThemeSwitcher";
import { getLocalStorageItem } from "../../../utils/HelperFunctions";
import { useUserGroups } from "../../../components/common/Auth/UserGroupsContext";
import SidebarMobileHeader from "./SidebarMobileHeader";
import SidebarMenu from "./SidebarMenu";
import { useHeaderProfileContext, useEDPContext } from "../../EDPContext";
var previousSelectedMWqtab = "";
var curretSelectedAQtab = "";
const Sidebar = ({
  source,
  onSelectComponent,
  componentType,
  onClose,
  onViewInfoClick,
  handleLogout,
  showComponent,
  callingFrom,
  mobileSidebar,
  toggleAdjustMainClass,
  onSelectTab,
  isCollapsed,
  setIsCollapsed
  
}) => {
  const defaultLDSettings = {
    station: 'Al Ain Islamic Institute',
    date: null,
  };
  const isPortalUser = getLocalStorageItem('portalUser') === 'true';
  const currentYear = new Date().getFullYear();
  const defaultHDSettings = {
    station: 6,
    duration: '1 Hr',
    year: [currentYear - 5, currentYear]
  }
  const { t } = useTranslation();
  const location = useLocation();
  const { groupNames, groupFunctions } = useUserGroups();
  const { isSidebarDisabled } = useHeaderProfileContext();
  let { theme, toggleTheme } = useTheme();
  theme = localStorage.getItem("theme") || theme;
  const [isUsersGroupsOpen, setIsUsersGroupsOpen] = useState(false);
  const [isPortalConfigOpen, setIsPortalConfigOpen] = useState(false);
  const [isDomainConfigOpen, setIsDomainConfigOpen] = useState(false);
  const [isIncidentsGroupsOpen, setIsIncidentsGroupsOpen] = useState(false);
  const [isReportsGroupOpen, setIsReportsGroupOpen] = useState(false);
  const [isDownoadDataGroupOpen, setIsDownoadDataGroupOpen] = useState(false);
  const [isAQConfigOpen, setIsAQConfigOpen] = useState(false);
  const [isDashboardOpen, setIsDashboardOpen] = useState(false);
  const [isAirQualityOpen, setIsAirQualityOpen] = useState(true);
  const [isEDPGroupsOpen, setIsEDPGroupsOpen] = useState(false);
  const [activeComponent, setActiveComponent] = useState("");
  const [isMetadataOpen, setIsmetadataOpen] = useState(false);
  const [isSMOpen, setIsSMOpen] = useState(false);
  const [isSDOpen, setIsSDOpen] = useState(false);
  const [isDataQCOpen, setIsDataQCOpen] = useState(false);
  const [isBuoysAlertsOpen, setIsBuoysAlertsOpen] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [downloadDataExpanded, setDownloadDataExpanded] = useState(false);
  const [isloggedIn, setIsLoggedIn] = useState(false);
  const [activePage, setActivePage] = useState("PDProjects");
  const [mwqactiveTab, setMwqActiveTab] = useState(
    window.mwqindiceshide === "show" ? "indices" : "parameters"
  );
  const userAgent = navigator.userAgent || "";
  const nativeApp = userAgent.includes("EDPFlutterApp") || localStorage.getItem("webView") == "true";
  const { AQStationsInfo, setAQStationsInfo,
    setAQLDSettings, setAQHDSettings, globalDataContextValue, setGeoJsonData, setForecastingFilters } = useEDPContext();
  const { globalData, setGlobalData } = globalDataContextValue;

  const checkLoginStatus = () => {
    const token = getLocalStorageItem("token");
    if (token) {
      setIsLoggedIn(true);
    }
  };
  const isMWQIndicesVisible = window.mwqindiceshide === "show";
  let userEmail;
  let username;
  if (
    getLocalStorageItem("username") !== "" &&
    getLocalStorageItem("username") !== null
  ) {
    username = getLocalStorageItem("username");
    userEmail = localStorage.getItem("UEmail");
  }

  useEffect(() => {
    checkLoginStatus(); // Check login status on component mount
  }, []);

  // State to manage the toggle switch
  const [isChecked, setIsChecked] = useState(theme === "dark");

  // Handle toggle change
  const handleToggleChange = () => {
    toggleTheme();
    setIsChecked(!isChecked);
  
  };

  const SidebarPathConfig = [
    {
      paths: ["/manage-users", "/manage-groups", "/user-action-logs"],
      setState: () => setIsUsersGroupsOpen(true),
    },
    {
      paths: ["/eadadmin"],
      setState: () => setIsDashboardOpen(true),
    },
    {
      paths: ["/manage-applications", "/manage-themes"],
      setState: () => setIsEDPGroupsOpen(true),
    },
    {
      paths: [
        // "/manage-metadata",
        "/manage-datastorecatlogs",
        "/manage-metadatconfig",
        "/manage-newmetadataconfig"
      ],
      setState: () => setIsmetadataOpen(true),
    },
    {
      paths: [
        "/manage-mapfunctions",
        "/manage-mapservices",
        "/manage-queries",
        "/manage-relatedlinks",
        "/feedback",
        "/manage-satellite-imageries",
        "/manage-download-logs",
        "/data-requests",
        "/data-extractionlogs",
      ],
      setState: () => setIsPortalConfigOpen(true),
    },
    {
      paths: [
        "/manage-projects",
        "/manage-categories",
        "/manage-parameters",
        "/manage-stations",
        "/manage-sites",
        "/manage-MWQStations",
        "/manage-vendors",
      ],
      setState: () => setIsDomainConfigOpen(true),
    },
    {
      paths: ["/manage-AQStations"],
      setState: () => setIsAQConfigOpen(true),
    },
    {
      paths: ["/buoys-alerts"],
      setState: () => setIsBuoysAlertsOpen(true),
    },
    {
      paths: ["/samples-management", "/samples-management/add"],
      setState: () => setIsSMOpen(true),
    },
    {
      paths: ["/sample-dashboard"],
      setState: () => setIsSDOpen(true),
    },
    {
      paths: ["/data-qc", "/data-qc/edit", "/data-qc/review", "/buoys-qc"],
      setState: () => setIsDataQCOpen(true),
    },
    {
      paths: ["/incidents/buoys-incidents", "/incidents/blooms-incidents", "/incidents/fishKills-incidents"],
      setState: () => setIsIncidentsGroupsOpen(true),
    },
    {
      paths: ["/reports/sample-status", "/reports/sample-history"],
      setState: () => setIsSDOpen(true),
    },
    {
      paths: [
        "/downloadData/download-mwq-station-data",
        "/downloadData/download-parameters-data",
        "/downloadData/download-mwq-data",
        "/downloadData/download-buoys-data",
        "/downloadData/download-mwq-indicies-data",
      ],
      setState: () => setIsDownoadDataGroupOpen(true),
    },
  ];

  useEffect(() => {
    const currentPath = location.pathname;
    SidebarPathConfig.forEach(({ paths, setState }) => {
      if (paths.some((path) => currentPath.startsWith(path))) {
        setState();
      }
    });
  }, [location]);
  const toggleIncidentsGroups = () => {
    setIsIncidentsGroupsOpen(!isIncidentsGroupsOpen);
    setIsReportsGroupOpen(false);
    setIsDownoadDataGroupOpen(false);
    setIsSMOpen(false);
    setIsSDOpen(false);
    setIsDataQCOpen(false);
    setIsBuoysAlertsOpen(false);
  };

  const toggleReportsConfig = () => {
    setIsIncidentsGroupsOpen(false);
    setIsReportsGroupOpen(!isReportsGroupOpen);
    setIsDownoadDataGroupOpen(false);
    setIsSMOpen(false);
    setIsSDOpen(false);
    setIsDataQCOpen(false);
    setIsBuoysAlertsOpen(false);
  };

  const toggleDownloadDataConfig = () => {
    setIsIncidentsGroupsOpen(false);
    setIsReportsGroupOpen(false);
    setIsDownoadDataGroupOpen(!isDownoadDataGroupOpen);
    setIsSMOpen(false);
    setIsSDOpen(false);
    setIsDataQCOpen(false);
    setIsBuoysAlertsOpen(false);
  };
  const toggleSD = () => {
    setIsSDOpen(!isSDOpen);
    setIsSMOpen(false);
    setIsDataQCOpen(false);
    setIsBuoysAlertsOpen(false);
    setIsIncidentsGroupsOpen(false);
    setIsReportsGroupOpen(false);
    setIsDownoadDataGroupOpen(false);
  };
  const toggleSM = () => {
    setIsSMOpen(!isSMOpen);
    setIsSDOpen(false);
    setIsDataQCOpen(false);
    setIsBuoysAlertsOpen(false);
    setIsIncidentsGroupsOpen(false);
    setIsReportsGroupOpen(false);
    setIsDownoadDataGroupOpen(false);
  };
  const toggleDataQC = () => {
    setIsSMOpen(false);
    setIsSDOpen(false);
    setIsDataQCOpen(!isDataQCOpen);
    setIsBuoysAlertsOpen(false);
    setIsIncidentsGroupsOpen(false);
    setIsReportsGroupOpen(false);
    setIsDownoadDataGroupOpen(false);
  };
  const toggleBuoysAlerts = () => {
    setIsSMOpen(false);
    setIsSDOpen(false);
    setIsDataQCOpen(false);
    setIsBuoysAlertsOpen(!isBuoysAlertsOpen);
    setIsIncidentsGroupsOpen(false);
    setIsReportsGroupOpen(false);
    setIsDownoadDataGroupOpen(false);
  };

  const toggleUsersGroups = () => {
    setIsDashboardOpen(false);
    setIsUsersGroupsOpen(!isUsersGroupsOpen);
    setIsPortalConfigOpen(false);
    setIsDomainConfigOpen(false);
    setIsAQConfigOpen(false);
    setIsEDPGroupsOpen(false);
    setIsmetadataOpen(false);
  };

  const toggleEDPGroup = () => {
    setIsDashboardOpen(false);
    setIsUsersGroupsOpen(false);
    setIsPortalConfigOpen(false);
    setIsDomainConfigOpen(false);
    setIsAQConfigOpen(false);
    setIsEDPGroupsOpen(!isEDPGroupsOpen);
    setIsmetadataOpen(false);
  };
  const toggleMetaGroup = () => {
    setIsDashboardOpen(false);
    setIsUsersGroupsOpen(false);
    setIsPortalConfigOpen(false);
    setIsDomainConfigOpen(false);
    setIsAQConfigOpen(false);
    setIsEDPGroupsOpen(false);
    setIsmetadataOpen(!isMetadataOpen);
  };
  const togglePortalConfig = () => {
    setIsDashboardOpen(false);
    setIsUsersGroupsOpen(false);
    setIsPortalConfigOpen(!isPortalConfigOpen);
    setIsAQConfigOpen(false);
    setIsEDPGroupsOpen(false);
    setIsDomainConfigOpen(false);
    setIsmetadataOpen(false);
  };

  const toggleDomainConfig = () => {
    setIsDashboardOpen(false);
    setIsUsersGroupsOpen(false);
    setIsPortalConfigOpen(false);
    setIsAQConfigOpen(false);
    setIsDomainConfigOpen(!isDomainConfigOpen);
    setIsEDPGroupsOpen(false);
    setIsmetadataOpen(false);
  };

  const toggleAQConfig = () => {
    setIsDashboardOpen(false);
    setIsUsersGroupsOpen(false);
    setIsPortalConfigOpen(false);
    setIsAQConfigOpen(!isAQConfigOpen);
    setIsDomainConfigOpen(false);
    setIsEDPGroupsOpen(false);
    setIsmetadataOpen(false);
  };

  const toggleDashboard = () => {
    setIsUsersGroupsOpen(false);
    setIsPortalConfigOpen(false);
    setIsDomainConfigOpen(false);
    setIsAQConfigOpen(false);
    setIsDashboardOpen(!isDashboardOpen);
    setIsEDPGroupsOpen(false);
    setIsmetadataOpen(false);
  };

  const AdminMobileRemoveSidebar = () => {
    document.querySelector("body").classList.remove("toggle-sidebar");
    document.querySelector("body").classList.remove("sdmMobFix");
  };

  const toggleAirQuality = () => {
    setIsAirQualityOpen(!isAirQualityOpen);
  };
  const handleComponentClick = (component) => {
    if (component === "indices" && !isMWQIndicesVisible) {
      component = "parameters";
    }

    previousSelectedMWqtab = activeComponent;

    // First reset data for the current subtab if switching to a different component beacuse need to reset previously selected filters
    setGlobalData(prevData =>
      prevData.map(module => {
        if (module.moduleName !== "MWQ") return module;


        const updatedSubTabs = module.subTabs.map(subtab => ({
          name: subtab.name,  // Keep the name
          filters: {},        // Reset filters
          prevFilters: {},    // Reset previous filters
          data: [],           // Reset main data
          // Reset all other arrays to empty
          ...(Object.fromEntries(
            Object.entries(subtab)
              .filter(([key]) => Array.isArray(subtab[key]))
              .map(([key]) => [key, []])
          ))
        }));

        return {
          ...module,
          subTabs: updatedSubTabs,
          selectedMWQOption: component
        };
      })
    );
    if (["indices", "parameters"].includes(component)) {

      onSelectComponent('interactiveAnalysis');
      setActiveComponent('interactiveAnalysis');
      onSelectTab(component);
      setMwqActiveTab(component);
      setGlobalData((prev) =>
        prev.map((module) =>
          module.moduleName === "MWQ"
            ? {
              ...module,
              activeComponent: "interactiveAnalysis",
              activetab: component
            }
            : module
        )
      );
      if (component != previousSelectedMWqtab && previousSelectedMWqtab != ""){
        isSidebarDisabled.current = true
      }
    }
    else if (["Monitor Water Quality Sites", "Parameter Data", "MWQ Data", "Buoys Data", "MWQ Indicies Data", "Vendor Reports"].includes(component)) {
      onSelectComponent('Download Data');
      setActiveComponent('Download Data');
      onSelectTab(component);
      setMwqActiveTab(component);
      setGlobalData((prev) =>
        prev.map((module) =>
          module.moduleName === "MWQ"
            ? {
              ...module,
              activeComponent: "Download Data",
              activetab: component
            }
            : module
        )
      );
    }
    else {
      setActiveComponent(component);
      onSelectComponent(component);
      onSelectTab(component);
      if (component != previousSelectedMWqtab) {
        isSidebarDisabled.current = true
      }
      setGlobalData((prev) =>
        prev.map((module) =>
          module.moduleName === "MWQ"
            ? {
              ...module,
              activeComponent: component,
              activetab: component
            }
            : module
        )
      );

    }
  };

  useEffect(() => {
    if (activeComponent === "MWQLiveData" || activeComponent === "MWQCaptureData") {
      document.body.classList.add('exporthideThisBtn');
    } else {
      document.body.classList.remove('exporthideThisBtn');
    }
  }, [activeComponent]);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const sidebarClose = () => {
    if (window.innerWidth <= 768) {
      setIsSidebarOpen(false);
    }
  };
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsSidebarOpen(true); // Always open on larger screens
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize(); // Initial check on mount

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  let SDMSidebarItems = [
    {
      label: t("samplesDashboard"),
      path: "/sample-dashboard",
      groupCheck: [window.userGroups?.sdmDataEntry, window.userGroups?.SampleManagementTool],
      toggle: toggleSD,
      isOpen: isSDOpen,
      className: "greenColorSidebar",
    },
    {
      label: t("samplesManagement"),
      path: "/samples-management",
      groupCheck: [window.userGroups?.sdmDataEntry],
      toggle: toggleSM,
      isOpen: isSMOpen,
      className: "greenColorSidebar",
    },

    {
      label: t("dataQC"),
      toggle: toggleDataQC,
      isOpen: isDataQCOpen,
      groupCheck: [
        window.userGroups?.sdmDataQC,
        window.userGroups?.sdmTechnician, window.userGroups?.sdmSME
      ],
      subItems: [
        {
          label: t("dataQCPeriodicMonitoring"),
          path: "/data-qc",
          groupCheck: [window.userGroups?.sdmDataQC],
        },
        {
          label: t("buoysQC"), path: "/buoys-qc",
          groupCheck: [
            window.userGroups?.sdmTechnician, window.userGroups?.sdmSME
          ],
        },
      ],
    },
    {
      label: t("buyosAlerts"),
      path: "/buoys-alerts",
      funCheck: [window.userFunctions?.sdmAlert],
      toggle: toggleBuoysAlerts,
      isOpen: isBuoysAlertsOpen,
      className: "greenColorSidebar",
    },
    {
      label: t("incidents"),
      toggle: toggleIncidentsGroups,
      isOpen: isIncidentsGroupsOpen,
      funCheck: [window.userFunctions?.sdmIndcidents],
      subItems: [
        {
          label: t("buoys"),
          path: "/incidents/buoys-incidents",
        },
        {
          label: t("bloom"),
          path: "/incidents/blooms-incidents",
        },
        // { label: t("Fishkills"), path: "/incidents/fishKills-incidents" },
      ],
    },
    // {
    //   label: t("reports"),
    //   toggle: toggleReportsConfig,
    //   isOpen: isReportsGroupOpen,
    //   funCheck: [window.userFunctions?.mwqReports],
    //   subItems: [
    //     { label: t("sampleStatus"), path: "/reports/sample-status" },
    //     // { label: t("sampleHistory"), path: "/reports/sample-history" },
    //   ],
    // },
    // {
    //   label: t("downloadData"),
    //   funCheck: [window.userFunctions?.sdmDataDownload],
    //   toggle: toggleDownloadDataConfig,
    //   isOpen: isDownoadDataGroupOpen,
    //   subItems: [
    //     {
    //       label: t("monitorStationData"),
    //       path: "/downloadData/download-mwq-station-data",
    //     },
    //     {
    //       label: t("parameterData"),
    //       path: "/downloadData/download-parameters-data",
    //     },
    //     {
    //       label: t("mwqData"),
    //       path: "/downloadData/download-mwq-data",
    //     },
    //     { label: t("buoysData"), path: "/downloadData/download-buoys-data" },
    //     {
    //       label: t("mwqIndiciesData"),
    //       path: "/downloadData/download-mwq-indicies-data",
    //     },
    //   ],
    // },
  ];

  const EadAminSidebarItems = [
    {
      label: t("Dashboard"),
      path: "/eadadmin",
      toggle: toggleDashboard,
      isOpen: isDashboardOpen,
      groupCheck: [window.userGroups?.admin],
      boldText: true,
    },
    {
      label: t("manageUsersGroups"),
      toggle: toggleUsersGroups,
      isOpen: isUsersGroupsOpen,
      groupCheck: [window.userGroups?.admin],
      subItems: [
        { label: t("manageUsers"), path: "/manage-users" },
        { label: t("manageGroups"), path: "/manage-groups" },
        { label: t("userActionLogs"), path: "/user-action-logs" },
      ],
    },
    {
      label: t("EDPManagement"),
      toggle: toggleEDPGroup,
      isOpen: isEDPGroupsOpen,
      groupCheck: [window.userGroups?.admin],
      subItems: [
        { label: t("Applications"), path: "/manage-applications" },
        { label: t("themes"), path: "/manage-themes" },
      ],
    },
    {
      label: t("portalConfiguration"),
      toggle: togglePortalConfig,
      isOpen: isPortalConfigOpen,
      groupCheck: [window.userGroups?.admin],
      subItems: [
        { label: t("Map Functions"), path: "/manage-mapfunctions" },
        { label: t("mapServices"), path: "/manage-mapservices" },
        { label: t("Search Queries"), path: "/manage-queries" },
        { label: t("Related Links"), path: "/manage-relatedlinks" },
        { label: t("Data Extraction"), path: "/data-extractionlogs" },
        { label: t("Feedbacks"), path: "/feedback" },
        {
          label: t("Manage Satellite Imageries"),
          path: "/manage-satellite-imageries",
        },

      ],
    },
    {
      label: t("MWQ Management"),
      toggle: toggleDomainConfig,
      isOpen: isDomainConfigOpen,
      groupCheck: [window.userGroups?.mwqAdmin, window.userGroups?.admin],
      subItems: [
        { label: t("configureProject"), path: "/manage-projects" },
        { label: t("MWQCategories"), path: "/manage-categories" },
        { label: t("MWQParameters"), path: "/manage-parameters" },
        { label: t("ConfigureBuoy"), path: "/manage-stations" },
        { label: t("Manage Sample Sites"), path: "/manage-sites" },
        { label: t("manageBuoys"), path: "/manage-MWQStations" },
        { label: t("Manage Vendors"), path: "/manage-vendors" },
        { label: t("Configure Vendor Report"), path: "/configure-vendors" },
      ],
    },
    {
      label: t("AQ Management"),
      toggle: toggleAQConfig,
      isOpen: isAQConfigOpen,
      groupCheck: [window.userGroups?.aqAdmin, window.userGroups?.admin],
      subItems: [
        { label: t("manageAQStationsVisibility"), path: "/manage-AQStations" },
      ],
    },
    {
      label: t("Metadata Management"),
      toggle: toggleMetaGroup,
      isOpen: isMetadataOpen,
      groupCheck: [window.userGroups?.admin],
      subItems: [
        { label: t("MetadataDashboard"), path: "/manage-metadataDasboard" },
        { label: t("DataStoreCatalog"), path: "/manage-datastorecatlogs" },
        { label: t("metadataconfiguaration"), path: "/manage-metadatconfig" },
        // { label: t("Metadata"), path: "/manage-metadata" },
        { label: t("Metadata"), path: "/manage-newmetadataconfig" },
      ],
    },
  ];

  const handleSidebarClick = (pageId) => {
    setActivePage(pageId);
  };


  const isSdm = source === "sdm";
  const menuItems = useMemo(() => {
    return isSdm
      ? SDMSidebarItems
      : EadAminSidebarItems;
  }, [
    isSdm,
    isDashboardOpen,
    isUsersGroupsOpen,
    isPortalConfigOpen,
    isDomainConfigOpen,
    isAQConfigOpen,
    isEDPGroupsOpen,
    isMetadataOpen,
    isDataQCOpen,
    isIncidentsGroupsOpen
  ]);


  if (source === "sdm" || source === "eadadmin") {
    // const isSdm = source === "sdm";
    // const menuItems = isSdm ? SDMSidebarItems : EadAminSidebarItems;

    return (
      <div
        className={
          mobileSidebar
            ? `sidebar enviportal-admin-sidebar mobSidebar-admin d-block d-sm-block d-md-none ${isSdm ? "sdm" : ""
            }`
            : `sidebar enviportal-admin-sidebar d-none d-sm-none d-md-block ${isSdm ? "sidesdmBar" : ""
            }`
        }
      >
        {mobileSidebar && (
          <SidebarMobileHeader
            username={username}
            userEmail={userEmail}
            theme={theme}           
            onViewInfoClick={onViewInfoClick}
            handleLogout={handleLogout}
            onClose={AdminMobileRemoveSidebar}
            handleToggleChange={handleToggleChange}
            callingFrom="sample"
          />
        )}
        <SidebarMenu menuItems={menuItems} groupNames={groupNames} groupFunctions={groupFunctions} onClose={AdminMobileRemoveSidebar} />
      </div>
    );
  }

  else if (source === "enviroportal") {
    return (
      <div>
        {/* Header menu for mobile responsive design -- start */}
        <div className="sidebar-header">
          <div className="sidebar-title">
            <MdKeyboardArrowLeft
              style={{ color: "white", marginRight: "5px" }}
              size={25}
              onClick={onClose}
            />
            {componentType === "marine" && <span>{t("mwqlabel")}</span>}
            {componentType === "airquality" && <span>{t("Air Quality")}</span>}
          </div>
          <div className="side-hamburger-icon">
            <MdMenu
              size={25}
              onClick={toggleSidebar}
              style={{ cursor: "pointer", color: "#fff" }}
            />
          </div>
        </div>
        {/* Header menu for mobile responsive design -- end */}
        <div
          className={`sidebar enviportal-admin-sidebar AQ-MWQ-AdvAnalSidebar ${isSidebarOpen ? "open" : ""
            }`}
        >
          <div
            className="navig-arrow-icon me-2 ms-2 mb-3 text-right d-none d-sm-none d-md-block d-lg-block"
            style={{ cursor: "pointer" }}
          >
            <img
              onClick={toggleAdjustMainClass}
              src={`${process.env.PUBLIC_URL}/images/fullsidebar-menu-icon.svg`}
              alt=""
              className="hambInvertDarkFilter"
            />
          </div>
          <ul className="sidebar-menu pt-4">
            {componentType === "marine" && (
              <li className="sidebar-item">
                <div
                  onClick={toggleUsersGroups}
                  className={`${true ? "sidebar-link-active-parent" : "sidebar-link"
                    }`}
                >
                  <span className="sidebar-text">{t("mwqlabel")}</span>
                  <span className="sidebar-icon">
                    {isUsersGroupsOpen ? (
                      <MdKeyboardArrowDown
                        style={{ color: "white", marginBottom: "5px" }}
                        size={20}
                      />
                    ) : (
                      <MdKeyboardArrowRight
                        style={{ color: "white", marginBottom: "5px" }}
                        size={20}
                      />
                    )}
                  </span>
                </div>
                <div className="sidebarClose">
                  <RxCross2
                    size={20}
                    onClick={() => sidebarClose()}
                    style={{ cursor: "pointer" }}
                  />
                </div>
                {true && (
                  <ul className={`sidebar-submenu ${isSidebarDisabled.current ? 'disabled' : ''}`}  >

                    {isloggedIn && groupNames.includes(window.userGroups.mwqInternal) ? (
                      <>
                        <li
                          onClick={() => {
                            handleComponentClick("MWQLiveData");
                            setDownloadDataExpanded(false);
                            setExpanded(false);
                            sidebarClose();
                          }}
                          className={
                            `sidebar-subitem ${showComponent === "MWQLiveData" || showComponent === 4 ? "subitem-active" : ""
                            }`
                          }
                        >
                          <div
                            className={
                              `sidebar-sublink ${showComponent === "MWQLiveData" || showComponent === 4 ? "active" : ""
                              }`
                            }
                            style={{ padding: "10px 20px", cursor: "pointer" }}
                          >
                            <img className="me-2 ms-1" src={`${process.env.PUBLIC_URL}/images/live 1.svg`} alt="LiveData-icon" />
                            <span>{t("BuoysLiveData")}</span>
                          </div>
                        </li>
                        {isMWQIndicesVisible && (
                        <li
                          onClick={() => {
                            handleComponentClick("MWQIndices");
                            setExpanded(false);
                            setDownloadDataExpanded(false);
                            sidebarClose();
                          }}
                          className={`sidebar-subitem ${showComponent === "MWQIndices" || showComponent === 0
                            ? "subitem-active"
                            : ""
                            }`}
                        >
                          <div
                            className={`sidebar-sublink ${showComponent === "MWQIndices" || showComponent === 0
                              ? "active"
                              : ""
                              }`}
                            style={{ padding: "10px 20px", cursor: "pointer" }}
                          >
                            <img
                              className="me-2 ms-1"
                              src={`${process.env.PUBLIC_URL}/images/mwq-indices.svg`}
                              alt="MWQIndices-icon" style={{ marginTop: '-8px' }}
                            />
                            <span>{t("MWQ Indices")}</span>
                          </div>
                        </li>
                        )}

                        <li
                          onClick={() => {
                            handleComponentClick("MWQCaptureData");
                            setExpanded(false);
                            setDownloadDataExpanded(false);
                            sidebarClose();
                          }}
                          className={
                            `sidebar-subitem ${showComponent === "MWQCaptureData" || showComponent === 5 ? "subitem-active" : ""
                            }`
                          }
                        >
                          <div
                            className={
                              `sidebar-sublink ${showComponent === "MWQCaptureData" || showComponent === 5 ? "active" : ""
                              }`
                            }
                            style={{ padding: "10px 20px", cursor: "pointer" }}
                          >
                            <img className="me-2 ms-1 mb-1" src={`${process.env.PUBLIC_URL}/images/data-capture.svg`} alt="Data capture-icon" />
                            <span>{t("Buoys Capture Data")}</span>
                          </div>
                        </li>

                        <li
                          onClick={() => {
                            handleComponentClick("historicaldata");
                            setExpanded(false);
                            setDownloadDataExpanded(false);
                            sidebarClose();
                          }}
                          className={
                            `sidebar-subitem ${showComponent === "historicaldata" || showComponent === 1
                              ? "subitem-active"
                              : ""
                            } `
                          }
                        >
                          <div
                            className={
                              `sidebar-sublink ${showComponent === "historicaldata" || showComponent === 1
                                ? "active"
                                : ""
                              } `
                            }
                            style={{ padding: "10px 20px", cursor: "pointer" }}
                          >
                            <img className="me-2 ms-1" src={`${process.env.PUBLIC_URL}/images/history 1.svg`} alt="History Icon" style={{ marginTop: '-6px' }} />
                            <span>{t("Buoys Analytics")}</span>
                          </div>
                        </li>
                        <li
                          onClick={() => {
                            if (!expanded) setExpanded(true); // Toggle expand state
                            if (downloadDataExpanded) setDownloadDataExpanded(false);
                            handleComponentClick("indices");
                            sidebarClose();
                          }}
                          className={`sidebar-subitem ${expanded ? "subitem-active" : ""}`}
                        >
                          <div

                            className={`sidebar-sublink pd-down-10 ${expanded ? "active" : ""
                              }`}
                            style={{ padding: "10px 20px", cursor: "pointer" }}
                          >
                            <img
                              className="me-2 ms-1"
                              src={`${process.env.PUBLIC_URL}/images/trend 1.svg`}
                              alt="Trend Icon"
                            />
                            <span>{t("MWQ Analytics")}</span>
                            {expanded ? (
                              <MdKeyboardArrowDown style={{ marginBottom: "2px" }} size={20} />
                            ) : (
                              <MdKeyboardArrowRight style={{ marginBottom: "2px" }} size={20} />
                            )}
                          </div>
                          {expanded && (
                            <ul className="sidebar-sublist mwq-sublisting">
                              {isMWQIndicesVisible && (
                              <li
                                onClick={(e) => {
                                  e.stopPropagation(); // Prevent the parent li onClick from toggling
                                  handleComponentClick("indices");
                                  setExpanded(true); // Keep MWQ Analytics expanded
                                }}
                                className={`sidebar-subitem ${mwqactiveTab === "indices" ? "subitem-active" : ""
                                  }`}
                              >
                                <div className="sidebar-sublink" style={{ padding: "10px 20px 0 20px" }}>
                                  <span>{t("Indices")}</span>
                                </div>
                              </li>
                              )}

                              <li
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleComponentClick("parameters");
                                }}
                                className={`sidebar-subitem ${mwqactiveTab === "parameters" ? "subitem-active" : ""
                                  }`}
                              >
                                <div className="sidebar-sublink" style={{ padding: "5px 20px 0 20px" }}>
                                  <span>{t("Parameters")}</span>
                                </div>
                              </li>
                            </ul>
                          )}
                        </li>
                        {isPortalUser && <li onClick={() => {
                          handleComponentClick("incidents");
                          setExpanded(false);
                          setDownloadDataExpanded(false);
                          sidebarClose();
                        }}
                          className={
                            `sidebar-subitem ${showComponent === "incidents" || showComponent === 3
                              ? "subitem-active"
                              : ""
                            } `
                          }>
                          <div className={
                            `sidebar-sublink ${showComponent === "incidents" || showComponent === 3 ? "active" : ""
                            }`

                          }
                            style={{ padding: "10px 20px", cursor: "pointer" }}
                          >
                            <img className="me-2 ms-1" src={`${process.env.PUBLIC_URL}/images/incident-icon.svg`} alt="Incident Icon" style={{ marginTop: '-6px' }} />
                            <span>{t("viewIncidents")}</span>
                          </div>
                        </li>}

                        {!nativeApp && (
                          <li
                            onClick={() => {
                              if (!downloadDataExpanded) setDownloadDataExpanded(true); // Toggle expand state    
                              if (expanded) setExpanded(false);
                              handleComponentClick("Monitor Water Quality Sites");
                              sidebarClose();
                            }}
                            className={`acma sidebar-subitem ${downloadDataExpanded ? "subitem-active" : ""}`}
                          >
                            <div

                              className={`sidebar-sublink pd-down-10 ${downloadDataExpanded ? "active" : ""
                                }`}
                              style={{ padding: "10px 20px", cursor: "pointer" }}
                            >
                              <img
                                className="me-2 ms-2"
                                src={`${process.env.PUBLIC_URL}/images/mwqDownlodIc.svg`}
                                alt="Trend Icon"
                              />
                              <span>{t("downloadData")}</span>
                              {downloadDataExpanded ? (
                                <MdKeyboardArrowDown style={{ marginBottom: "2px" }} size={20} />
                              ) : (
                                <MdKeyboardArrowRight style={{ marginBottom: "2px" }} size={20} />
                              )}
                            </div>
                            {downloadDataExpanded && (
                              <ul className="sidebar-sublist mwq-sublisting">
                                {/* Indices */}
                                <li
                                  onClick={(e) => {
                                    e.stopPropagation(); // Prevent the parent li onClick from toggling
                                    handleComponentClick("Monitor Water Quality Sites");
                                    setDownloadDataExpanded(true); // Keep MWQ Analytics expanded
                                  }}
                                  className={`sidebar-subitem ${mwqactiveTab === "Monitor Water Quality Sites" ? "subitem-active" : ""
                                    }`}
                                >
                                  <div className="sidebar-sublink" style={{ padding: "10px 14px 0 14px" }}>
                                    <span>{t("monitorStationData")}</span>
                                  </div>
                                </li>

                                {/* Parameters */}
                                <li
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleComponentClick("Parameter Data");
                                  }}
                                  className={`sidebar-subitem ${mwqactiveTab === "Parameter Data" ? "subitem-active" : ""
                                    }`}
                                >
                                  <div className="sidebar-sublink" style={{ padding: "5px 14px 0 14px" }}>
                                    <span>{t("parameterData")}</span>
                                  </div>
                                </li>
                                <li
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleComponentClick("MWQ Data");
                                  }}
                                  className={`sidebar-subitem ${mwqactiveTab === "MWQ Data" ? "subitem-active" : ""
                                    }`}
                                >
                                  <div className="sidebar-sublink" style={{ padding: "5px 14px 0 14px" }}>
                                    <span>{t("mwqData")}</span>
                                  </div>
                                </li>
                                <li
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleComponentClick("Buoys Data");
                                  }}
                                  className={`sidebar-subitem ${mwqactiveTab === "Buoys Data" ? "subitem-active" : ""
                                    }`}
                                >
                                  <div className="sidebar-sublink" style={{ padding: "5px 14px 0 14px" }}>
                                    <span>{t("buoysData")}</span>
                                  </div>
                                </li>
                                {isMWQIndicesVisible && (
                                <li
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleComponentClick("MWQ Indicies Data");
                                  }}
                                  className={`sidebar-subitem ${mwqactiveTab === "MWQ Indicies Data" ? "subitem-active" : ""
                                    }`}
                                >
                                  <div className="sidebar-sublink" style={{ padding: "5px 14px 0 14px" }}>
                                    <span>{t("mwqIndiciesData")}</span>
                                  </div>
                                </li>
                                )}
                                <li
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleComponentClick("Vendor Reports");
                                  }}
                                  className={`sidebar-subitem ${mwqactiveTab === "Vendor Reports" ? "subitem-active" : ""
                                    }`}
                                >
                                  <div className="sidebar-sublink" style={{ padding: "5px 14px 0 14px" }}>
                                    <span>{t("vendorReports")}</span>
                                  </div>
                                </li>
                              </ul>
                            )}
                          </li>
                        )}
                      </>
                    ) : isloggedIn ? (
                      <>
                        {isMWQIndicesVisible && (
                        <div>
                          <li
                            onClick={() => {
                              handleComponentClick("MWQIndices");
                              setExpanded(false);
                              sidebarClose();
                            }}
                            className={`sidebar-subitem ${showComponent === "MWQIndices" || showComponent === 0
                              ? "subitem-active"
                              : ""
                              }`}
                          >
                            <div
                              className={`sidebar-sublink ${showComponent === "MWQIndices" || showComponent === 0
                                ? "active"
                                : ""
                                }`}
                              style={{ padding: "10px 20px", cursor: "pointer" }}
                            >
                              <img
                                className="me-2 ms-1"
                                src={`${process.env.PUBLIC_URL}/images/mwq-indices.svg`}
                                alt="MWQIndices-icon" style={{ marginTop: '-8px' }}
                              />
                              <span>{t("MWQ Indices")}</span>
                            </div>
                          </li>
                        </div>
                        )}
                        {/* Buoy Analytics Menu */}
                        {groupNames.includes(window.userGroups.buoyAnalytics) && (
                          <>
                            <li
                              onClick={() => {
                                handleComponentClick("MWQLiveData");
                                setExpanded(false);
                                sidebarClose();
                              }}
                              className={
                                `sidebar-subitem ${showComponent === "MWQLiveData" || showComponent === 4 ? "subitem-active" : ""
                                }`
                              }
                            >
                              <div
                                className={
                                  `sidebar-sublink ${showComponent === "MWQLiveData" || showComponent === 4 ? "active" : ""
                                  }`
                                }
                                style={{ padding: "10px 20px", cursor: "pointer" }}
                              >
                                <img className="me-2 ms-1" src={`${process.env.PUBLIC_URL}/images/live 1.svg`} alt="LiveData-icon" />
                                <span>{t("BuoysLiveData")}</span>
                              </div>
                            </li>

                            <li
                              onClick={() => {
                                handleComponentClick("MWQCaptureData");
                                setExpanded(false);
                                sidebarClose();
                              }}
                              className={
                                `sidebar-subitem ${showComponent === "MWQCaptureData" || showComponent === 5 ? "subitem-active" : ""
                                }`
                              }
                            >
                              <div
                                className={
                                  `sidebar-sublink ${showComponent === "MWQCaptureData" || showComponent === 5 ? "active" : ""
                                  }`
                                }
                                style={{ padding: "10px 20px", cursor: "pointer" }}
                              >
                                <img className="me-2 ms-1 mb-1" src={`${process.env.PUBLIC_URL}/images/data-capture.svg`} alt="Data capture-icon" />
                                <span>{t("Buoys Capture Data")}</span>
                              </div>
                            </li>
                            <li
                              onClick={() => {
                                handleComponentClick("historicaldata");
                                setExpanded(false);
                                sidebarClose();
                              }}
                              className={
                                `sidebar-subitem ${showComponent === "historicaldata" || showComponent === 1
                                  ? "subitem-active"
                                  : ""
                                } `
                              }
                            >
                              <div
                                className={
                                  `sidebar-sublink ${showComponent === "historicaldata" || showComponent === 1
                                    ? "active"
                                    : ""
                                  } `
                                }
                                style={{ padding: "10px 20px", cursor: "pointer" }}
                              >
                                <img className="me-2 ms-1" src={`${process.env.PUBLIC_URL}/images/history 1.svg`} alt="History Icon" style={{ marginTop: '-6px' }} />
                                <span>{t("Buoys Analytics")}</span>
                              </div>
                            </li>
                          </>
                        )}
                        {groupNames.includes(window.userGroups.mwqAnalytics) && (
                          <>
                            <li
                              onClick={() => {
                                if (!expanded) setExpanded(true); // Toggle expand state                          
                                handleComponentClick("indices");
                                sidebarClose();
                              }}
                              className={`sidebar-subitem ${expanded ? "subitem-active" : ""}`}
                            >
                              <div

                                className={`sidebar-sublink pd-down-10 ${expanded ? "active" : ""
                                  }`}
                                style={{ padding: "10px 20px", cursor: "pointer" }}
                              >
                                <img
                                  className="me-2 ms-1"
                                  src={`${process.env.PUBLIC_URL}/images/trend 1.svg`}
                                  alt="Trend Icon"
                                />
                                <span>{t("MWQ Analytics")}</span>
                                {expanded ? (
                                  <MdKeyboardArrowDown style={{ marginBottom: "2px" }} size={20} />
                                ) : (
                                  <MdKeyboardArrowRight style={{ marginBottom: "2px" }} size={20} />
                                )}
                              </div>
                              {expanded && (
                                <ul className="sidebar-sublist mwq-sublisting">
                                  {isMWQIndicesVisible && (
                                  <li
                                    onClick={(e) => {
                                      e.stopPropagation(); // Prevent the parent li onClick from toggling
                                      handleComponentClick("indices");
                                      setExpanded(true); // Keep MWQ Analytics expanded
                                    }}
                                    className={`sidebar-subitem ${mwqactiveTab === "indices" ? "subitem-active" : ""
                                      }`}
                                  >
                                    <div className="sidebar-sublink" style={{ padding: "10px 20px 0 20px" }}>
                                      <span>{t("Indices")}</span>
                                    </div>
                                  </li>
                                  )}

                                  <li
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleComponentClick("parameters");
                                    }}
                                    className={`sidebar-subitem ${mwqactiveTab === "parameters" ? "subitem-active" : ""
                                      }`}
                                  >
                                    <div className="sidebar-sublink" style={{ padding: "5px 20px 0 20px" }}>
                                      <span>{t("Parameters")}</span>
                                    </div>
                                  </li>
                                </ul>
                              )}
                            </li>
                          </>
                        )}
                        {groupNames.includes(window.userGroups.mwqviewIncidents) && isPortalUser && (
                          <>
                            <li onClick={() => {
                              handleComponentClick("incidents");
                              setExpanded(false);
                              sidebarClose();
                            }}
                              className={
                                `sidebar-subitem ${showComponent === "incidents" || showComponent === 3
                                  ? "subitem-active"
                                  : ""
                                } `
                              }>
                              <div className={
                                `sidebar-sublink ${showComponent === "incidents" || showComponent === 3 ? "active" : ""
                                }`

                              }
                                style={{ padding: "10px 20px", cursor: "pointer" }}
                              >
                                <img className="me-2 ms-1" src={`${process.env.PUBLIC_URL}/images/incident-icon.svg`} alt="Incident Icon" style={{ marginTop: '-6px' }} />
                                <span>{t("viewIncidents")}</span>
                              </div>
                            </li>
                          </>
                        )}
                        {(groupNames.includes(window.userGroups.mwqDownloadData) && !nativeApp) && (
                          <>
                            <li
                              onClick={() => {
                                if (!downloadDataExpanded) setDownloadDataExpanded(true); // Toggle expand state    
                                if (expanded) setExpanded(false);
                                handleComponentClick("Monitor Water Quality Sites");
                                sidebarClose();
                              }}
                              className={`aft sidebar-subitem ${downloadDataExpanded ? "subitem-active" : ""}`}
                            >
                              <div

                                className={`sidebar-sublink pd-down-10 ${downloadDataExpanded ? "active" : ""
                                  }`}
                                style={{ padding: "10px 20px", cursor: "pointer" }}
                              >
                                <img
                                  className="me-2 ms-2"
                                  src={`${process.env.PUBLIC_URL}/images/mwqDownlodIc.svg`}
                                  alt="Trend Icon"
                                />
                                <span>{t("downloadData")}</span>
                                {downloadDataExpanded ? (
                                  <MdKeyboardArrowDown style={{ marginBottom: "2px" }} size={20} />
                                ) : (
                                  <MdKeyboardArrowRight style={{ marginBottom: "2px" }} size={20} />
                                )}
                              </div>
                              {downloadDataExpanded && (
                                <ul className="sidebar-sublist mwq-sublisting">
                                  {/* Indices */}
                                  <li
                                    onClick={(e) => {
                                      e.stopPropagation(); // Prevent the parent li onClick from toggling
                                      handleComponentClick("Monitor Water Quality Sites");
                                      setDownloadDataExpanded(true); // Keep MWQ Analytics expanded
                                    }}
                                    className={`sidebar-subitem ${mwqactiveTab === "Monitor Water Quality Sites" ? "subitem-active" : ""
                                      }`}
                                  >
                                    <div className="sidebar-sublink" style={{ padding: "10px 14px 0 14px" }}>
                                      <span>{t("monitorStationData")}</span>
                                    </div>
                                  </li>

                                  {/* Parameters */}
                                  <li
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleComponentClick("Parameter Data");
                                    }}
                                    className={`sidebar-subitem ${mwqactiveTab === "Parameter Data" ? "subitem-active" : ""
                                      }`}
                                  >
                                    <div className="sidebar-sublink" style={{ padding: "5px 14px 0 14px" }}>
                                      <span>{t("parameterData")}</span>
                                    </div>
                                  </li>
                                  <li
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleComponentClick("MWQ Data");
                                    }}
                                    className={`sidebar-subitem ${mwqactiveTab === "MWQ Data" ? "subitem-active" : ""
                                      }`}
                                  >
                                    <div className="sidebar-sublink" style={{ padding: "5px 14px 0 14px" }}>
                                      <span>{t("mwqData")}</span>
                                    </div>
                                  </li>
                                  <li
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleComponentClick("Buoys Data");
                                    }}
                                    className={`sidebar-subitem ${mwqactiveTab === "Buoys Data" ? "subitem-active" : ""
                                      }`}
                                  >
                                    <div className="sidebar-sublink" style={{ padding: "5px 14px 0 14px" }}>
                                      <span>{t("buoysData")}</span>
                                    </div>
                                  </li>
                                  {isMWQIndicesVisible && (
                                  <li
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleComponentClick("MWQ Indicies Data");
                                    }}
                                    className={`sidebar-subitem ${mwqactiveTab === "MWQ Indicies Data" ? "subitem-active" : ""
                                      }`}
                                  >
                                    <div className="sidebar-sublink" style={{ padding: "5px 14px 0 14px" }}>
                                      <span>{t("mwqIndiciesData")}</span>
                                    </div>
                                  </li>
                                  )}
                                  <li
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleComponentClick("Vendor Reports");
                                    }}
                                    className={`sidebar-subitem ${mwqactiveTab === "Vendor Reports" ? "subitem-active" : ""
                                      }`}
                                  >
                                    <div className="sidebar-sublink" style={{ padding: "5px 14px 0 14px" }}>
                                      <span>{t("vendorReports")}</span>
                                    </div>
                                  </li>
                                </ul>
                              )}
                            </li>
                          </>
                        )}
                      </>
                    ) : isMWQIndicesVisible ? (<>
                      <div>
                        <li
                          onClick={() => {
                            handleComponentClick("MWQIndices");
                            setExpanded(false);
                            sidebarClose();
                          }}
                          className={`sidebar-subitem ${showComponent === "MWQIndices" || showComponent === 0
                            ? "subitem-active"
                            : ""
                            }`}
                        >
                          <div
                            className={`sidebar-sublink ${showComponent === "MWQIndices" || showComponent === 0
                              ? "active"
                              : ""
                              }`}
                            style={{ padding: "10px 20px", cursor: "pointer" }}
                          >
                            <img
                              className="me-2 ms-1"
                              src={`${process.env.PUBLIC_URL}/images/mwq-indices.svg`}
                              alt="MWQIndices-icon" style={{ marginTop: '-8px' }}
                            />
                            <span>{t("MWQ Indices")}</span>
                          </div>
                        </li>
                      </div>
                    </>) : null}


                    {/* isloggedIn && groupNames.includes(window.userGroups.buoyAnalytics) ? (
                    <>
                      <li
                        onClick={() => {
                          handleComponentClick("MWQLiveData");
                          setExpanded(false);
                          sidebarClose();
                        }}
                        className={
                          `sidebar-subitem ${showComponent === "MWQLiveData" || showComponent === 4 ? "subitem-active" : ""
                          }`
                        }
                      >
                        <div
                          className={
                            `sidebar-sublink ${showComponent === "MWQLiveData" || showComponent === 4 ? "active" : ""
                            }`
                          }
                          style={{ padding: "10px 20px", cursor: "pointer" }}
                        >
                          <img className="me-2 ms-1" src={`${process.env.PUBLIC_URL}/images/live 1.svg`} alt="LiveData-icon" />
                          <span>{t("BuoysLiveData")}</span>
                        </div>
                      </li>

                      <li
                        onClick={() => {
                          handleComponentClick("MWQCaptureData");
                          setExpanded(false);
                          sidebarClose();
                        }}
                        className={
                          `sidebar-subitem ${showComponent === "MWQCaptureData" || showComponent === 5 ? "subitem-active" : ""
                          }`
                        }
                      >
                        <div
                          className={
                            `sidebar-sublink ${showComponent === "MWQCaptureData" || showComponent === 5 ? "active" : ""
                            }`
                          }
                          style={{ padding: "10px 20px", cursor: "pointer" }}
                        >
                          <img className="me-2 ms-1 mb-1" src={`${process.env.PUBLIC_URL}/images/data-capture.svg`} alt="Data capture-icon" />
                          <span>{t("Buoys Capture Data")}</span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          handleComponentClick("historicaldata");
                          setExpanded(false);
                          sidebarClose();
                        }}
                        className={
                          `sidebar-subitem ${showComponent === "historicaldata" || showComponent === 1
                            ? "subitem-active"
                            : ""
                          } `
                        }
                      >
                        <div
                          className={
                            `sidebar-sublink ${showComponent === "historicaldata" || showComponent === 1
                              ? "active"
                              : ""
                            } `
                          }
                          style={{ padding: "10px 20px", cursor: "pointer" }}
                        >
                          <img className="me-2 ms-1" src={`${process.env.PUBLIC_URL}/images/history 1.svg`} alt="History Icon" style={{ marginTop: '-6px' }} />
                          <span>{t("Buoys Analytics")}</span>
                        </div>
                      </li>
                    </>
                    ) : isloggedIn && groupNames.includes(window.userGroups.mwqAnalytics) ? (
                    <>
                      <li
                        onClick={() => {
                          if (!expanded) setExpanded(true); // Toggle expand state                          
                          handleComponentClick("indices");
                          sidebarClose();
                        }}
                        className={`sidebar-subitem ${expanded ? "subitem-active" : ""}`}
                      >
                        <div

                          className={`sidebar-sublink pd-down-10 ${expanded ? "active" : ""
                            }`}
                          style={{ padding: "10px 20px", cursor: "pointer" }}
                        >
                          <img
                            className="me-2 ms-1"
                            src={`${process.env.PUBLIC_URL}/images/trend 1.svg`}
                            alt="Trend Icon"
                          />
                          <span>{t("MWQ Analytics")}</span>
                          {expanded ? (
                            <MdKeyboardArrowDown style={{ marginBottom: "2px" }} size={20} />
                          ) : (
                            <MdKeyboardArrowRight style={{ marginBottom: "2px" }} size={20} />
                          )}
                        </div>
                        {expanded && (
                          <ul className="sidebar-sublist mwq-sublisting">
                            {isMWQIndicesVisible && (
                            <li
                              onClick={(e) => {
                                e.stopPropagation(); // Prevent the parent li onClick from toggling
                                handleComponentClick("indices");
                                setExpanded(true); // Keep MWQ Analytics expanded
                              }}
                              className={`sidebar-subitem ${mwqactiveTab === "indices" ? "subitem-active" : ""
                                }`}
                            >
                              <div className="sidebar-sublink" style={{ padding: "10px 20px 0 20px" }}>
                                <span>{t("Indices")}</span>
                              </div>
                            </li>
                            )}

                            <li
                              onClick={(e) => {
                                e.stopPropagation();
                                handleComponentClick("parameters");
                              }}
                              className={`sidebar-subitem ${mwqactiveTab === "parameters" ? "subitem-active" : ""
                                }`}
                            >
                              <div className="sidebar-sublink" style={{ padding: "5px 20px 0 20px" }}>
                                <span>{t("Parameters")}</span>
                              </div>
                            </li>
                          </ul>
                        )}
                      </li>
                    </>
                    ) : isloggedIn && groupNames.includes(window.userGroups.mwqviewIncidents) ? (
                    <>
                      <li onClick={() => {
                        handleComponentClick("incidents");
                        setExpanded(false);
                        sidebarClose();
                      }}
                        className={
                          `sidebar-subitem ${showComponent === "incidents" || showComponent === 3
                            ? "subitem-active"
                            : ""
                          } `
                        }>
                        <div className={
                          `sidebar-sublink ${showComponent === "incidents" || showComponent === 3 ? "active" : ""
                          }`

                        }
                          style={{ padding: "10px 20px", cursor: "pointer" }}
                        >
                          <img className="me-2 ms-1" src={`${process.env.PUBLIC_URL}/images/incident-icon.svg`} alt="Incident Icon" style={{ marginTop: '-6px' }} />
                          <span>{t("viewIncidents")}</span>
                        </div>
                      </li>
                    </>
                    ) : (
                    <div>
                       <li
                          onClick={() => {
                            handleComponentClick("MWQIndices");
                            setExpanded(false);
                            sidebarClose();
                          }}
                          className={`sidebar-subitem ${showComponent === "MWQIndices" || showComponent === 0
                            ? "subitem-active"
                            : ""
                            }`}
                        >
                          <div
                            className={`sidebar-sublink ${showComponent === "MWQIndices" || showComponent === 0
                              ? "active"
                              : ""
                              }`}
                            style={{ padding: "10px 20px", cursor: "pointer" }}
                          >
                            <img
                              className="me-2 ms-1"
                              src={`${process.env.PUBLIC_URL}/images/mwq-indices.svg`}
                              alt="MWQIndices-icon" style={{ marginTop: '-8px' }}
                            />
                            <span>{t("MWQ Indices")}</span>
                          </div>
                        </li>
                    </div>
                    )}
                    <div>
                      <li
                        onClick={() => {
                          handleComponentClick("MWQIndices");
                          setExpanded(false);
                          sidebarClose();
                        }}
                        className={`sidebar-subitem ${showComponent === "MWQIndices" || showComponent === 0
                          ? "subitem-active"
                          : ""
                          }`}
                      >
                        <div
                          className={`sidebar-sublink ${showComponent === "MWQIndices" || showComponent === 0
                            ? "active"
                            : ""
                            }`}
                          style={{ padding: "10px 20px", cursor: "pointer" }}
                        >
                          <img
                            className="me-2 ms-1"
                            src={`${process.env.PUBLIC_URL}/images/mwq-indices.svg`}
                            alt="MWQIndices-icon" style={{ marginTop: '-8px' }}
                          />
                          <span>{t("MWQ Indices")}</span>
                        </div>
                      </li>
                    </div> */}
                  </ul>
                )}
              </li>
            )}

            {componentType === "airquality" && (
              <li className="sidebar-item">
                <div
                  onClick={toggleAirQuality}
                  className={`${isAirQualityOpen
                    ? "sidebar-link-active-parent"
                    : "sidebar-link"
                    }`}
                >
                  <span className="sidebar-text">{t("Air Quality")}</span>
                  <span className="sidebar-icon">
                    {isAirQualityOpen ? (
                      <MdKeyboardArrowDown
                        style={{ color: "white", marginBottom: "5px" }}
                        size={20}
                      />
                    ) : (
                      <MdKeyboardArrowRight
                        style={{ color: "white", marginBottom: "5px" }}
                        size={20}
                      />
                    )}
                  </span>
                </div>
                <div className="sidebarClose">
                  <RxCross2
                    size={20}
                    onClick={() => sidebarClose()}
                    style={{ cursor: "pointer" }}
                  />
                </div>
                {isAirQualityOpen && (
                  <ul className="sidebar-submenu">
                    <li
                      className={`sidebar-subitem ${showComponent === "AirLiveComponent" ||
                        showComponent === "0"
                        ? "active-analytic"
                        : ""
                        }`}
                      onClick={(evt) => {
                        //Reset filters and data when the user switches dropdown options - this clears any previously selected filters
                        curretSelectedAQtab = "AirLiveComponent";
                        if (curretSelectedAQtab != activeComponent) {
                          setAQLDSettings(defaultLDSettings);
                        }
                        setActiveComponent("AirLiveComponent")
                        setGlobalData((prev) =>
                          prev.map((module) =>
                            module.moduleName === "AirQuality"
                              ? {
                                ...module,
                                activeComponentValue: "0",
                                activeComponentLabel: "LiveData"
                              }
                              : module
                          )
                        );
                      }}
                    >
                      <div
                        className={`sidebar-sublink ${showComponent === "AirLiveComponent"
                          ? "active-link"
                          : ""
                          }`}
                        onClick={() => {
                          onSelectComponent("AirLiveComponent");
                          sidebarClose();
                        }}
                        style={{ padding: "10px 20px", cursor: "pointer" }}
                      >
                        <img
                          className="me-2 ms-1"
                          src={`${process.env.PUBLIC_URL}/images/live 1.svg`}
                          alt="Live Icon"
                        />
                        <span>{t("liveData")}</span>
                      </div>
                    </li>

                    {(isloggedIn && groupNames.includes(window.userGroups.aqInternal)) && (
                      <>
                        <li
                          className={`sidebar-subitem ${showComponent === "historicaldata" ||
                            showComponent === "1"
                            ? "active-analytic"
                            : ""
                            }`}
                          onClick={() => {
                            curretSelectedAQtab = "historicaldata";
                            //Reset filters and data when the user switches dropdown options - this clears any previously selected filters
                            if (curretSelectedAQtab != activeComponent) {
                              setAQHDSettings(defaultHDSettings);
                            }
                            setActiveComponent("historicaldata")
                            setGlobalData((prev) =>
                              prev.map((module) =>
                                module.moduleName === "AirQuality"
                                  ? {
                                    ...module,
                                    activeComponentValue: "1",
                                    activeComponentLabel: "Detailed Analysis"
                                  }
                                  : module
                              )
                            );
                          }}
                        >
                          <div
                            className={`sidebar-sublink ${showComponent === "historicaldata"
                              ? "active-link"
                              : ""
                              }`}
                            onClick={() => {
                              onSelectComponent("historicaldata");
                              sidebarClose();
                            }}
                            style={{ padding: "10px 20px", cursor: "pointer" }}
                          >
                            <img
                              className="me-2 ms-1"
                              src={`${process.env.PUBLIC_URL}/images/history 1.svg`}
                              alt="History Icon"
                            />
                            <span>{t("Detailed Analysis")}</span>
                          </div>
                        </li>
                        <li
                          className={`sidebar-subitem ${showComponent === "interactiveAnalysis" ||
                            showComponent === "2"
                            ? "active-analytic"
                            : ""
                            }`}
                          onClick={() => {
                            //Reset filters and data when the user switches dropdown options - this clears any previously selected filters
                            curretSelectedAQtab = "interactiveAnalysis";
                            if (curretSelectedAQtab != activeComponent) {
                              setGlobalData((prev) =>
                                prev.map((module) =>
                                  module.moduleName === "AirQuality"
                                    ? {
                                      ...module,
                                      activeComponentValue: "2",
                                      activeComponentLabel: "Interactive Analysis",
                                      subTabs: module.subTabs.map((subTab) =>
                                        subTab.name === "InteractiveAnalysis"
                                          ? {
                                            ...subTab,
                                            filters: {},
                                            prevFilters: {},
                                            Filter: {},
                                            filtersToUpdate: [],
                                            data: [],
                                            regionData: [],
                                            locationData: [],
                                          }
                                          : subTab
                                      ),
                                    }
                                    : module
                                )
                              );
                            }
                            setActiveComponent("interactiveAnalysis")
                          }}
                        >
                          <div
                            className={`sidebar-sublink ${showComponent === "interactiveAnalysis"
                              ? "active-link"
                              : ""
                              }`}
                            onClick={() => {
                              onSelectComponent("interactiveAnalysis");
                              sidebarClose();
                            }}
                            style={{ padding: "10px 20px", cursor: "pointer" }}
                          >
                            <img
                              className="me-2 ms-1"
                              src={`${process.env.PUBLIC_URL}/images/trend 1.svg`}
                              alt="interactive Icon"
                            />
                            <span>{t("Interactive Analysis")}</span>
                          </div>
                        </li>
                        {(groupNames.includes(window.userGroups.AQForecasting)) && (
                          <li
                            className={`sidebar-subitem ${showComponent === "ForecastingAirComponent" ||
                              showComponent === "3"
                              ? "active-analytic"
                              : ""
                              }`}
                            onClick={() => {
                              //Reset filters and data when the user switches dropdown options - this clears any previously selected filters
                              curretSelectedAQtab = "ForecastingAirComponent";
                              if (curretSelectedAQtab != activeComponent) {
                                setGeoJsonData([]);
                                setForecastingFilters([]);
                              }
                              setActiveComponent("ForecastingAirComponent")
                              setGlobalData((prev) =>
                                prev.map((module) =>
                                  module.moduleName === "AirQuality"
                                    ? {
                                      ...module,
                                      activeComponentValue: "3",
                                      activeComponentLabel: "AQ AI Forecasting"
                                    }
                                    : module
                                )
                              );
                            }}
                          >
                            <div
                              className={`sidebar-sublink ${showComponent === "ForecastingAirComponent"
                                ? "active-link"
                                : ""
                                }`}
                              onClick={() => {
                                onSelectComponent("ForecastingAirComponent");
                                sidebarClose();
                              }}
                              style={{ padding: "10px 20px", cursor: "pointer" }}
                            >
                              <img
                                className="me-2 ms-1"
                                src={`${process.env.PUBLIC_URL}/images/cloud2.svg`}
                                alt="History Icon"
                              />
                              <span>{t("AQ AI Forecasting")}</span>
                            </div>
                          </li>
                        )}
                      </>
                    )}
                  </ul>
                )}
              </li>
            )}
          </ul>
        </div>
      </div >
    );
  }
  else if (source === "permit-dashboard") {
    return (
      <div>
        <div
          className={`sidebar envSidebar ${isCollapsed ? "collapsed" : ""
            }`}
        >
          <div
            className="navig-arrow-icon me-2 ms-2 mb-3 text-right d-none d-sm-none d-md-block d-lg-block"
            style={{ cursor: "pointer" }}
          >
            <img
              onClick={() => {
                setIsCollapsed(!isCollapsed);
              }}
              src={`${process.env.PUBLIC_URL}/images/fullsidebar-menu-icon.svg`}
              alt=""
              className="hambInvertDarkFilter"
            />
          </div>
          <ul className="sidebar-menu">
            <li className={`sidebar-item ${activePage === "PDProjects" ? "active" : ""}`}>
              <Link className="sidebar-link" to="/permit-dashboard/projects" onClick={() => handleSidebarClick("PDProjects")}>
                <img className="me-2 ms-1" src={`${process.env.PUBLIC_URL}/images/pd-projects-ico.svg`} alt="Projects" />
                {!isCollapsed && <span >{t("permitProjects")} </span>}
              </Link>
            </li>
            <li className={`sidebar-item ${activePage === "PDStudies" ? "active" : ""}`}>
              <Link className="sidebar-link" to="/permit-dashboard/studies" onClick={() => handleSidebarClick("PDStudies")}>
                <img className="me-2 ms-1" src={`${process.env.PUBLIC_URL}/images/pd-studies-ico.svg`} alt="Studies" />
                {!isCollapsed && <span >{t("permitStudies")}</span>}
              </Link>
            </li>
            <li className={`sidebar-item ${activePage === "PDEcoRegistration" ? "active" : ""}`}>
              <Link className="sidebar-link" to="/permit-dashboard/eco-registration" onClick={() => handleSidebarClick("PDEcoRegistration")}>
                <img className="me-2 ms-1" src={`${process.env.PUBLIC_URL}/images/pd-eco-ico.svg`} alt="Eco Registration" />
                {!isCollapsed && <span >{t("ecoRegistration")}</span>}
              </Link>
            </li>
            <li className={`sidebar-item ${activePage === "PDGroundWater" ? "active" : ""}`}>
              <Link className="sidebar-link" to="/permit-dashboard/ground-water" onClick={() => handleSidebarClick("PDGroundWater")}>
                <img className="me-2 ms-1" src={`${process.env.PUBLIC_URL}/images/pd-water-ico.svg`} alt="Ground Water" />
                {!isCollapsed && <span >{t("groundWater")}</span>}
              </Link>
            </li>
            <li className={`sidebar-item d-none ${activePage === "PDHistoricalMap" ? "active" : ""}`}>
              <Link className="sidebar-link" to="/permit-dashboard/historical-map" onClick={() => handleSidebarClick("PDHistoricalMap")}>
                <img className="me-2 ms-1" src={`${process.env.PUBLIC_URL}/images/hisMap.svg`} alt="Historical Map" />
                {!isCollapsed && <span >{t("historicalMap")}</span>}
              </Link>
            </li>
            <li className={`sidebar-item d-none ${activePage === "PDCumulative" ? "active" : ""}`}>
              <Link className="sidebar-link" to="/permit-dashboard/cumulative" onClick={() => handleSidebarClick("PDCumulative")}>
                <img className="me-2 ms-1" src={`${process.env.PUBLIC_URL}/images/cumulariveIcon.svg`} alt="Cumulative" />
                {!isCollapsed && <span >{t("cumulative")}</span>}
              </Link>
            </li>

          </ul>
        </div>
      </div>
    );
  }
};
export default Sidebar;